// Encabezado de la cotización: a nombre de quién sale y «hecha por» (JUNTA, SEGUNDA TANDA, Diego 13-oct). Diego, Miguel
// y Juan Carlos la cambian aquí mismo de vendedor; el servidor vuelve a revisar el permiso (403 a cualquier otro) y
// recalcula con la comisión, el tope y el precio de Optimus del nuevo vendedor. «Hecha por» nunca sale en el PDF.
import { useEffect, useState } from 'react';
import type { Usuario } from '@cotizador/compartido';
import { api } from '../../api/consultas.ts';
import { usarUsuario } from '../../sesion.tsx';
import { Boton, ErrorEnLinea } from '../../componentes/ui.tsx';
import { SelectorVendedor, cotizaANombreDeOtros } from '../../componentes/SelectorVendedor.tsx';
import { usarCotizacion } from './contexto.tsx';

/** «· Fernando Camou · hecha por Juan Carlos», para la línea de datos del encabezado. */
export function TextoVendedor() {
  const { detalle } = usarCotizacion();
  return (
    <>
      {' · '}
      {detalle.vendedor_nombre}
      {detalle.creada_por_nombre ? <span title="Quién la capturó (no sale en el PDF)"> · hecha por {detalle.creada_por_nombre}</span> : null}
    </>
  );
}

/** Botón «Cambiar vendedor» y su hoja, solo para quien cotiza a nombre de otros y puede editar esta cotización. */
export function CambiarVendedor() {
  const { cot, ejecutar } = usarCotizacion();
  const { usuario, puedeEn } = usarUsuario();
  const [usuarios, setUsuarios] = useState<Usuario[]>([]);
  const [abierto, setAbierto] = useState(false);
  const [elegido, setElegido] = useState(cot.vendedor_id);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState<unknown>(null);
  const editable = usuario.rol !== 'externo' && puedeEn('editar_cotizaciones', cot);
  useEffect(() => {
    if (!editable) return;
    let vivo = true;
    api
      .usuarios()
      .then((r) => vivo && setUsuarios(r.usuarios))
      .catch(() => vivo && setUsuarios([]));
    return () => {
      vivo = false;
    };
  }, [editable]);
  useEffect(() => setElegido(cot.vendedor_id), [cot.vendedor_id]);
  if (!editable || !cotizaANombreDeOtros(usuarios, usuario.id)) return null;

  async function guardar() {
    setGuardando(true);
    setError(null);
    try {
      await ejecutar((c) => api.actualizarCrm(c.id, { revision: c.revision, vendedor_id: elegido }));
      setAbierto(false);
    } catch (e) {
      setError(e);
    } finally {
      setGuardando(false);
    }
  }

  if (!abierto)
    return (
      <Boton variante="noche" chico onClick={() => setAbierto(true)}>
        Cambiar vendedor
      </Boton>
    );
  return (
    <div className="hoja pila">
      <SelectorVendedor usuarios={usuarios} yoId={usuario.id} valor={elegido} alCambiar={setElegido} disabled={guardando} />
      <ErrorEnLinea error={error} alCerrar={() => setError(null)} />
      <div className="fila-botones fila-botones--fin">
        <Boton
          onClick={() => {
            setElegido(cot.vendedor_id);
            setAbierto(false);
          }}
          disabled={guardando}
        >
          Cancelar
        </Boton>
        <Boton variante="principal" cargando={guardando} disabled={elegido === cot.vendedor_id} onClick={() => void guardar()}>
          Poner a su nombre
        </Boton>
      </div>
    </div>
  );
}
